module.exports = __webpack_public_path__ + "static/media/gro_flo_fir_gro.19603ce9.png";